// initial state
const state = {
    isOpen: false,
    proxyChatRoomId: -1
};

// getters
const getters = {};

// actions
const actions = {
    openFloatingChatroom({ commit }, payload) {
        if (payload) {
            let potentialChatRoomId = -1;
            if (payload.chatRoomId) potentialChatRoomId = payload.chatRoomId;
            commit('setProxyChatroom', potentialChatRoomId);
        }
        commit('setIsOpen', true);
        return true;
    },
    closeFloatingChatroom({ commit }) {
        commit('setProxyChatroom', -1);
        commit('setIsOpen', false);
        return true;
    },
    resetProxyChatRoomId({ commit }) {
        commit('setProxyChatroom', -1);
        return true;
    }
};

// mutations
const mutations = {
    setIsOpen(state, isOpen) {
        state.isOpen = isOpen;
    },
    setProxyChatroom(state, chatRoomId) {
        state.proxyChatRoomId = chatRoomId;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
